module.exports = __webpack_public_path__ + "static/img/server16.5fc7600.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/server16.png
// module id = pCvB
// module chunks = 1